module.exports = __webpack_public_path__ + "img/ic_appstore_google.c1ee3caa.svg";